import { Bank, GraduationCap, Heartbeat, Leaf, Wheelchair } from "@phosphor-icons/react";

const ICONS = { GraduationCap, Wheelchair, Leaf, Heartbeat, Bank };

export function ProblemIcon({ name, weight = "regular", className = "" }) {
  const Icon = ICONS[name] ?? GraduationCap;
  return <Icon className={className} weight={weight} aria-hidden="true" />;
}
